import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router';
import { App } from './App';
import { FalhaDaApi } from './api/cliente';
import { PortalApp } from './portal/PortalApp';
import { SessaoProvedor } from './sessao/SessaoProvedor';
import './estilos/tema.css';

const cliente = new QueryClient({
  defaultOptions: {
    queries: {
      // Sessão expirada não é caso de repetir: repetir três vezes só atrasa a volta
      // ao login. Erro de rede, sim — a conexão pode ter oscilado.
      retry: (tentativas, erro) => {
        if (erro instanceof FalhaDaApi && erro.exigeLogin) return false;
        return tentativas < 2;
      },
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});

const raiz = document.getElementById('raiz');
if (!raiz) throw new Error('Elemento raiz não encontrado no documento.');

createRoot(raiz).render(
  <StrictMode>
    <QueryClientProvider client={cliente}>
      <BrowserRouter>
        {/* A separação entre os dois públicos acontece AQUI, antes de qualquer
            provedor de sessão — e não dentro do <App/>.

            O portal da clínica e o sistema do escritório têm cookies, guardas e
            telas próprios. Se o <SessaoProvedor/> do escritório envolvesse os dois,
            toda visita da clínica dispararia um pedido de sessão da equipe, ficaria
            presa no "Abrindo o sistema…" e, no fim, cairia na tela de login errada. */}
        <Routes>
          <Route path="/portal/*" element={<PortalApp />} />
          <Route
            path="*"
            element={
              <SessaoProvedor>
                <App />
              </SessaoProvedor>
            }
          />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
